import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';

export default function SelectionCell(props) {
  const {
    cashTransferReqeust,
    selectionSet,
    setSelectionSet,
  } = props;

  if (cashTransferReqeust.cancelled) {
    return null;
  }
  const isSelected = selectionSet.findIndex(element => element.id === cashTransferReqeust.id) > -1;
  const key = `${cashTransferReqeust.id}-${isSelected}-${
    selectionSet.length > 0 ? selectionSet[0].currency : '___'
  }`;
  return (
    <Checkbox
      style={{ padding: '0px' }}
      checked={isSelected}
      key={key}
      disabled={
        selectionSet.length > 0
        && selectionSet[0].currency !== cashTransferReqeust.currency
      }
      size="small"
      color="primary"
      inputProps={{ 'aria-label': 'primary checkbox' }}
      onChange={(e) => {
        if (e.target.checked) {
          if (
            selectionSet.length === 0
            || selectionSet[0].currency === cashTransferReqeust.currency
          ) {
            const newSelectionSet = [...selectionSet, cashTransferReqeust];
            setSelectionSet(newSelectionSet);
          }
        } else {
          const indexIn = selectionSet.findIndex(
            element => element.id === cashTransferReqeust.id,
          );
          if (indexIn > -1) {
            selectionSet.splice(indexIn, 1);
            setSelectionSet([...selectionSet]);
          }
        }
      }}
    />
  );
}
